import { cn } from "@/utils";

/**
 * ChatDot — a chat row's lead in the rail.
 *
 * A list of chats is the densest thing the rail shows, and giving every row a
 * message-bubble glyph made the column read as noise: the same busy shape
 * repeated down the whole list, competing with the names that actually
 * distinguish one conversation from another. The design answers with a plain
 * small circle — quiet enough to disappear into the run, present enough to
 * hold the icon column's alignment.
 *
 * It still carries state: a chat that is working gets the accent, so the one
 * row you might be waiting on is the one row with colour. (lucide's
 * `circle-small` is not in this version — replicated to its spec so it slots
 * in like any lucide icon.)
 */
export function ChatDot({
  active = false,
  className,
}: {
  /** The chat is currently running — the only chat state worth colour. */
  active?: boolean;
  className?: string;
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={cn(
        "size-3.5 shrink-0",
        active ? "text-rust" : "text-n-40",
        className,
      )}
    >
      <circle cx="12" cy="12" r="4" />
    </svg>
  );
}
